import logo from 'Assets/Images/facet-logo.svg';
import { facetLogoUrl as facetLogo } from 'Consts/sharedUris';
import clients from 'Assets/Images/clients.svg';
import reporting from 'Assets/Images/reporting.svg';
import faq from 'Assets/Images/faq.png';
import board from 'Assets/Images/board.png';
import toolkit from 'Assets/Images/toolkit.png';
import hamburger from 'Assets/Images/hamburger.png';
import convo from 'Assets/Images/convo.png';
import refresh from 'Assets/Images/refresh-icon.svg';
import ripple from 'Assets/Images/ripple.gif';
import dashboardDependents from 'Assets/Images/client-dependents.svg';
import dashboardEmail from 'Assets/Images/client-email.svg';
import dashboardPhone from 'Assets/Images/client-phone.svg';
import dashboardServiceLevel from 'Assets/Images/client-service-level.svg';
import dashboardSpouse from 'Assets/Images/client-spouse.svg';
import notifications from 'Assets/Images/notifications.svg';
import dashboardTimeZone from 'Assets/Images/client-timezone.svg';
import complete from 'Assets/Images/complete.png';
import financialGoals from 'Assets/Images/financial-goals.svg';
import calendar from 'Assets/Images/calendar.svg';
import planning from 'Assets/Images/planning-dashboard.svg';
import prospects from 'Assets/Images/prospect-manager.svg';
import filterSliders from 'Assets/Images/filters-icon.svg';
import zoom from 'Assets/Images/magnifying-glass.svg';
import addIcon from 'Assets/Images/add.svg';
import removeIcon from 'Assets/Images/remove.svg';
import pencil from 'Assets/Images/pencil.svg';
import partners from 'Assets/Images/partners.svg';
import fileNotification from 'Assets/Images/file-notifications.svg';
import agreementSigned from 'Assets/Images/agreement-signed.svg';
import previewArrow from 'Assets/Images/preview.svg';
import lightboxArrow from 'Assets/Images/lightbox.svg';
import infoCircle from 'Assets/Images/info-circle.svg';
import geoPin from 'Assets/Images/advisorDashboardGeoPin.svg';
import notificationFilters from 'Assets/Images/notification-filters.svg';
import assetsUnderManagement from 'Assets/Images/aum-icon.svg';
import share from 'Assets/Images/share-ios.svg';

export default {
  logo,
  facetLogo,
  clients,
  reporting,
  faq,
  board,
  toolkit,
  hamburger,
  convo,
  ripple,
  refresh,
  dashboardDependents,
  dashboardEmail,
  dashboardPhone,
  dashboardServiceLevel,
  dashboardSpouse,
  dashboardTimeZone,
  complete,
  financialGoals,
  calendar,
  planning,
  prospects,
  filterSliders,
  zoom,
  addIcon,
  removeIcon,
  pencil,
  partners,
  notifications,
  fileNotification,
  agreementSigned,
  previewArrow,
  lightboxArrow,
  infoCircle,
  geoPin,
  notificationFilters,
  assetsUnderManagement,
  share,
};
